import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
import { CustomEase } from 'gsap/CustomEase'
import { GSDevTools } from 'gsap/GSDevTools'

gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase, GSDevTools)


CustomEase.create('osmo', 'M0,0 C0.625,0.05 0,1 1,1')
CustomEase.create("energy", "M0,0 C0.32,0.72 0,1 1,1")

export const initEnterAnimation = () => {
	const banner = document.querySelector('.banner')
	const header = document.querySelector('header')
	const video = document.querySelector('.wide-video')

	if (!banner || window.isLivePreview || window.innerWidth < 1024) {
		banner.classList.add('is-ready')
		return false
	}

	const heading = banner.querySelector('.banner__heading')
	const canvasHolder = banner.querySelector('.banner__canvas-holder')
	const radialPurple = banner.querySelector('.banner__radial-purple')
	const radialOrange = banner.querySelector('.banner__radial-orange')
	const announcement = banner.querySelector('.announcement')

	document.fonts.ready.then(() => {
		
		banner.classList.add('is-ready')

		const splitHeading = SplitText.create(heading, {
			type: 'lines, chars',
			linesClass: 'line++',
			mask: 'lines',
			aria: false
		})

		const words = heading.querySelectorAll('span')
		
		const tl = gsap.timeline()

		tl.fromTo(canvasHolder, {
			opacity: 0,
		}, {
			opacity: 1,
			duration: 1,
			ease: 'expo.out',
		})

		tl.fromTo(canvasHolder, {
			translate: '-50% 40%'
		}, {
			translate: '-50% -60%',
			duration: 1.75,
			ease: 'osmo',
		})

		tl.fromTo(radialPurple, {
			opacity: 0,
		}, {
			opacity: 0.6,
			duration: 4,
			ease: 'expo.out',
		}, 1.75)

		tl.fromTo(radialOrange, {
			opacity: 0.6,
		}, {
			opacity: 0,
			duration: 4,
			ease: 'expo.out',
		}, 1.75)

		tl.fromTo(words, {
			yPercent: 125,
		}, {
			yPercent: 0,
			duration: 2,
			stagger: 0.2,
			ease: 'energy',
		}, 2)

		tl.fromTo(header, {
			opacity: 0,
			y: '-150%'
		}, {
			y: '0%',
			opacity: 1,
			duration: 1.4,
			ease: 'osmo',
		}, '<')

		tl.fromTo(announcement, {
			opacity: 0,
			y: '110%'
		}, {
			y: '0%',
			opacity: 1,
			duration: 1.4,
			ease: 'osmo',
		}, 2.6)

		tl.fromTo(video, {
			opacity: 0,
			scale: 0.8,
		}, {
			scale: 1,
			opacity: 1,
			duration: 1.8,
			ease: 'energy',
		}, 2.7)

		// GSDevTools.create({ tl })

	})

}

export const initFooterParallax = () => {
	document.querySelectorAll('[data-footer-parallax]').forEach(el => {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'clamp(top bottom)',
				end: 'clamp(top top)',
				scrub: true
			}
		})

		const inner = el.querySelector('[data-footer-parallax-inner]')
		const dark = el.querySelector('[data-footer-parallax-dark]')

		if (inner) {
			tl.from(inner, {
				yPercent: -25,
				ease: 'linear'
			})
		}

		if (dark) {
			tl.from(dark, {
				opacity: 0.5,
				ease: 'linear'
			}, '<')
		}
	})
}

export const animVideoGrow = () => {
	const videos = document.querySelectorAll('.wide-video__holder')
	const tweens = []

	if (window.innerWidth < 650) return () => {}

	videos.forEach(video => {
		tweens.push(gsap.to(video, {
			scrollTrigger: {
				trigger: video,
				start: 'top bottom',
				end: 'bottom bottom',
				scrub: true,
				// markers: true
			},
			width: '100vw',
			borderRadius: '0'
		}))

		tweens.push(gsap.to(video, {
			scrollTrigger: {
				trigger: video,
				start: 'bottom bottom',
				end: 'bottom top',
				scrub: true,
				// markers: true
			},
			ease: 'linear',
			yPercent: 50,
			opacity: 0.5
		}))
	})

	return () => {
		tweens.forEach((tween) => {
			tween.scrollTrigger?.kill()
			tween.kill()
		})
	}
}

export const animHomeBanner = () => {
	const banner = document.querySelector('.banner')
	const video = document.querySelector('.wide-video__inner')

	if (!banner) return

	const heading = banner.querySelector('.banner__heading')
	const canvasHolder = banner.querySelector('.banner__canvas-holder')
	const canvasPurple = banner.querySelector('.banner__radial-purple')
	const canvasOrange = banner.querySelector('.banner__radial-orange')
	const announcement = banner.querySelector('.announcement')

	const splitHeading = SplitText.create(heading, {
		type: 'lines, chars',
		linesClass: 'line++',
		mask: 'lines',
		aria: false
	})

	const words = heading.querySelectorAll('span')

	const tl = gsap.timeline({ delay: 0.7 })
	
	gsap.set(canvasOrange, { opacity: 0 })
	gsap.set(canvasPurple, { opacity: 0.6 })
	
	banner.classList.add('is-ready')

	tl.fromTo(canvasHolder, {
		opacity: 0,
	}, {
		opacity: 1,
		duration: 1,
		ease: 'expo.out',
	})

	tl.fromTo(words, {
		yPercent: 125,
	}, {
		yPercent: 0,
		duration: 2,
		stagger: 0.2,
		ease: 'energy',
	}, '<')

	tl.fromTo(announcement, {
		opacity: 0,
		y: '110%'
	}, {
		y: '0%',
		opacity: 1,
		duration: 1.4,
		ease: 'osmo',
	}, '-=1.8')

	tl.fromTo(video, {
		opacity: 0,
		scale: 0.8,
	}, {
		scale: 1,
		opacity: 1,
		duration: 1.8,
		ease: 'energy',
	}, '-=1.4')

}

export const initAwardsGridImages = () => {
	const timers = []
	const sections = document.querySelectorAll('[data-awards-grid]')

	sections.forEach(section => {
		let currentIndex = 0
		const images = section.querySelectorAll('[data-awards-grid-image]')

		if (!images.length) return

		timers.push(setInterval(() => {
			nextImage(images[currentIndex], images)
			currentIndex++
			if (currentIndex >= images.length) {
				currentIndex = 0
			}
		}, 3000))
	})

	function nextImage(image, images) {
		images.forEach(image => image.classList.remove('is-active'))
		image.classList.add('is-active')
	}

	return () => {
		timers.forEach((timer) => clearInterval(timer))
	}
}

export const initAnimations = () => {
	return animVideoGrow()
}

export const initGlobalParallax = () => {
  const mm = gsap.matchMedia()

  mm.add(
    {
      isMobile: "(max-width:479px)",
      isMobileLandscape: "(max-width:767px)",
      isTablet: "(max-width:991px)",
      isDesktop: "(min-width:992px)"
    },
    (context) => {
      const { isMobile, isMobileLandscape, isTablet } = context.conditions

      const ctx = gsap.context(() => {
        document.querySelectorAll('[data-parallax="trigger"]').forEach((trigger) => {
            // Check if this trigger has to be disabled on smaller breakpoints
            const disable = trigger.getAttribute("data-parallax-disable")
            if (
              (disable === "mobile" && isMobile) ||
              (disable === "mobileLandscape" && isMobileLandscape) ||
              (disable === "tablet" && isTablet)
            ) {
              return
            }
            
            // Optional: you can target an element inside a trigger if necessary 
            const target = trigger.querySelector('[data-parallax="target"]') || trigger

            // Get the direction value to decide between xPercent or yPercent tween
            const direction = trigger.getAttribute("data-parallax-direction") || "vertical"
            const prop = direction === "horizontal" ? "xPercent" : "yPercent"
            
            // Get the scrub value, our default is 'true' because that feels nice with Lenis
            const scrubAttr = trigger.getAttribute("data-parallax-scrub")
            const scrub = scrubAttr ? parseFloat(scrubAttr) : true
            
            // Get the start position in % 
            const startAttr = trigger.getAttribute("data-parallax-start")
            const startVal = startAttr !== null ? parseFloat(startAttr) : 20
            
            // Get the end position in %
            const endAttr = trigger.getAttribute("data-parallax-end")
            const endVal = endAttr !== null ? parseFloat(endAttr) : -20
            
            // Get the start value of the ScrollTrigger
            const scrollStartRaw = trigger.getAttribute("data-parallax-scroll-start") || "top bottom"
            const scrollStart = `clamp(${scrollStartRaw})`
            
           // Get the end value of the ScrollTrigger  
            const scrollEndRaw = trigger.getAttribute("data-parallax-scroll-end") || "bottom top"
            const scrollEnd = `clamp(${scrollEndRaw})`

            gsap.fromTo(
              target,
              { [prop]: startVal },
              {
                [prop]: endVal,
                ease: "none",
                scrollTrigger: {
                  trigger,
                  start: scrollStart,
                  end: scrollEnd,
                  scrub,
                },
              }
            )
          })
      })

      return () => ctx.revert()
    }
  )

  return () => mm.revert()
}